/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { DisableOrgMemberOptions, DisableOrgMemberResponses } from '../../models/DisableOrgMember'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @summary Disable Org Member
 * {@link /org/member/:user_id/disable}
 */
export function disableOrgMember<ThrowOnError extends boolean = true>(options: Options<DisableOrgMemberOptions, ThrowOnError>): Promise<UnwrappedResult<DisableOrgMemberResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'POST', url: '/org/member/{user_id}/disable', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<DisableOrgMemberResponses, ThrowOnError>>
}
